import * as React from "react";
import {
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
  Tooltip as RadixTooltip,
} from "@radix-ui/react-tooltip";
import { twMerge } from "tailwind-merge";

interface Props {
  text: string | React.ReactNode;
  className?: string;
  side?: "top" | "right" | "bottom" | "left";
  delayDuration?: number;
  portalContainer?: HTMLElement;
}

export const Tooltip: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  text,
  className = "bg-white",
  delayDuration = 167,
  side,
  portalContainer,
}) => (
  <RadixTooltip delayDuration={delayDuration}>
    <TooltipTrigger asChild>{children}</TooltipTrigger>
    <TooltipPortal container={portalContainer}>
      <TooltipContent
        side={side}
        className={twMerge("rounded-b-sm p-3", className)}
        sideOffset={5}
        style={{ zIndex: 9999 }}
      >
        {text}
        <TooltipArrow className="TooltipArrow" />
      </TooltipContent>
    </TooltipPortal>
  </RadixTooltip>
);

export { TooltipProvider };
